import handleResponse from './request/handleResponse'

export default function(api: GlobalFetch) {
  return async function(status) {
    const response = await api.fetch(`/api/v2/airbnb/integration/`, {
      method: 'POST',
      body: JSON.stringify({
        status: status,
      }),
    })

    return await handleResponse(response)
  }
}
